import styled from 'styled-components';
import MEDIA from '../../helpers/mediaTemplates';
export const Text = styled.span.withConfig({
  displayName: "titlecss__Text",
  componentId: "sc-1gbyu2x-0"
})(["display:block;font-weight:", ";font-size:", ";line-height:1.2;", ";"], ({
  size
}) => () => {
  switch (size) {
    case 'large':
      return '400';
    default:
      return '500';
  }
}, ({
  size
}) => () => {
  switch (size) {
    case 'large':
      return '3.2rem';
    default:
      return '2rem';
  }
}, MEDIA.TABLET`
    font-size: ${({
  size
}) => () => {
  switch (size) {
    case 'large':
      return '2.6rem';
    default:
      return '2rem';
  }
}};
  `);